'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421 from "./presto.types$-Envelope-Title$$anon$21.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422 from "./presto.types$-Envelope-Title$$anon$22.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeTitle$() {
  this.c6H = null;
  this.c6I = false;
  this.c6F = null;
  this.c6G = false;
  this.c6J = null;
  this.c6K = false;
  this.c6L = null;
  this.c6M = false;
}
export { $c_Lpresto_types$EnvelopeTitle$ as $c_Lpresto_types$EnvelopeTitle$ };
$p = $c_Lpresto_types$EnvelopeTitle$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeTitle$;
/** @constructor */
function $h_Lpresto_types$EnvelopeTitle$() {
}
export { $h_Lpresto_types$EnvelopeTitle$ as $h_Lpresto_types$EnvelopeTitle$ };
$h_Lpresto_types$EnvelopeTitle$.prototype = $p;
$p.cIa = (function() {
  if ((!this.c6I)) {
    this.c6H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6I = true;
  }
  return this.c6H;
});
$p.nI = (function() {
  if ((!this.c6G)) {
    this.c6F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6G = true;
  }
  return this.c6F;
});
$p.cIC = (function() {
  if ((!this.c6K)) {
    this.c6J = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421.$c_Lpresto_types$EnvelopeTitle$$anon$21(this);
    this.c6K = true;
  }
  return this.c6J;
});
$p.cJ7 = (function() {
  if ((!this.c6M)) {
    this.c6L = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422.$c_Lpresto_types$EnvelopeTitle$$anon$22(this);
    this.c6M = true;
  }
  return this.c6L;
});
var $d_Lpresto_types$EnvelopeTitle$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeTitle$, "presto.types$EnvelopeTitle$", ({
  a01: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeTitle$ as $d_Lpresto_types$EnvelopeTitle$ };
var $n_Lpresto_types$EnvelopeTitle$;
function $m_Lpresto_types$EnvelopeTitle$() {
  if ((!$n_Lpresto_types$EnvelopeTitle$)) {
    $n_Lpresto_types$EnvelopeTitle$ = new $c_Lpresto_types$EnvelopeTitle$();
  }
  return $n_Lpresto_types$EnvelopeTitle$;
}
export { $m_Lpresto_types$EnvelopeTitle$ as $m_Lpresto_types$EnvelopeTitle$ };
//# sourceMappingURL=presto.types$-Envelope-Title$.js.map
